export const GOAL_REQUEST_DATA = 'GOAL/REQUEST_DATA';
export const GOAL_BEGIN_WRITE_DATA = 'GOAL/BEGIN_WRITE_DATA';
export const GOAL_COMPLETE_WRITE_DATA = 'GOAL/COMPLETE_WRITE_DATA';
export const RECEIVE_GOALS = 'GOAL/RECEIVE_GOALS';
